import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import { ButtonContainer } from "./Action.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import "../../MailTokenList.scss";

const Action = (props) => {
  const { t, data, editMailToken } = props;

  const handleEdit = () => {
    // Open edit popup with mail token data
    if (editMailToken) {
      editMailToken(data);
    }
  };

  return (
    <ButtonContainer>
      <div>
        <Image
          src={editIcon}
          onClick={handleEdit}
          title={t("GENERIC_ACTION_TOOLTIP_EDIT")}
          alt={t("GENERIC_ACTION_TOOLTIP_EDIT")}
          className="mailtoken-list__image-icon"
        />
      </div>
    </ButtonContainer>
  );
};

Action.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
  editMailToken: PropTypes.func,
};

export default withTranslation()(Action);
